<div class="table-container">
    <table *ngIf="excelData">
        <!-- Bandeau d'entête : correspond aux lignes 1 à 3 fusionnées dans l'Excel -->
        <thead>
            <tr>
                <th colspan="2">
                    <span class="fw-semibold">{{ current | uppercase }}</span>
                </th>
<th [attr.colspan]="excelData[3].length - 6" style="text-align: center; font-size: 15px;">                    {{ excelData[0][1] }}
                </th>
                <th colspan="4" style="text-align: right;">
                    {{ excelData[0][excelData[0].length - 1] }}
                </th>
            </tr>

            <!-- Ligne 4 de l'Excel : entêtes des colonnes -->
            <tr class="header-row">
                <th *ngFor="let header of excelData[3]">
                    {{ header }}
                </th>
            </tr>
        </thead>

        <!-- Données (à partir de la ligne 5, hors ligne "Total") -->
        <tbody>
            <tr *ngFor="let row of dataRows; let i = index" [class.selected]="selectedRowIndex === i"
                (click)="selectRow(i)">
                <td *ngFor="let cell of row; let j = index" class="truncate-cell"
                    [class.numeric-cell]="isNumeric(j)">
                    {{ isNumeric(j) ? (cell | number:'1.2-2':'fr-FR') : cell }}
                </td>
            </tr>
        </tbody>

        <!-- Ligne "Total" affichée en pied de tableau, mise en avant -->
        <tfoot *ngIf="totalRow">
            <tr class="total-row">
                <td *ngFor="let cell of totalRow; let j = index" [class.numeric-cell]="isNumeric(j)">
                    {{ isNumeric(j) ? (cell | number:'1.2-2':'fr-FR') : (j === 0 ? cell : '') }}
                </td>
            </tr>
        </tfoot>
    </table>
</div>